import { createSlice } from '@reduxjs/toolkit';
import { getMonitorViolations } from 'features/admin-monitoring/violations/async';
import { MonitoringViolationsState } from 'features/admin-monitoring/violations/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: MonitoringViolationsState = {
  violations: { data: undefined, request: initialRequestState },
};

const slice = createSlice({
  name: 'monitoringViolations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMonitorViolations.pending, (state, { meta }) => {
      state.violations.data = undefined;
      state.violations.request = requestReducer(
        state.violations.request,
        pending({ meta })
      );
    });
    builder.addCase(
      getMonitorViolations.fulfilled,
      (state, { meta, payload }) => {
        if (state.violations.request.id === meta.requestId) {
          state.violations.data = payload;
          state.violations.request = requestReducer(
            state.violations.request,
            fulfilled({ meta })
          );
        }
      }
    );
    builder.addCase(getMonitorViolations.rejected, (state, { meta }) => {
      state.violations.request = requestReducer(
        state.violations.request,
        rejected({ meta })
      );
    });
  },
});

const { reducer } = slice;

export default reducer;
